// extracted by mini-css-extract-plugin
export var container = "_6g-0";
export var error = "_6g-9";
export var label = "_6g-5";
export var light = "_6g-6";
export var md = "_6g-3";
export var sm = "_6g-2";
export var thin = "_6g-8";
export var thinBold = "_6g-7";
export var vertical = "_6g-4";
export var xs = "_6g-1";